import React from 'react';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import ActionButton from '../../components/ActionButton';
import ActionLink from '../../components/ActionLink';
import FileUploadService from '../../services/FileUploadService';
import ImageComponent from '../../components/inputs/ImageComponent';
import BaseContainer from '../../baseContainers/BaseContainer';

class EduMaterialComponent extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {};
        this.descriptionRef = React.createRef();
        this.fileUploadService = new FileUploadService();
        this.uploadPhotoHandler=this.uploadPhotoHandler.bind(this);
    }
    render() {
        const {idPrefix, t} = this.props;
        return (
            <div className='material-edu-div' style={{marginBottom: '3px'}}>
                <div className='row'>
                    <div className='col-12'>
                        <div className='p-card-header-minheight'>
                            <div className='header-item-right'>
                                <ActionButton
                                    label={t('quiz.deleteEduMaterial')}
                                    className='float-right'
                                    key={'next-button'}
                                    handleClick={(e) => this.props.handleRemoveMaterial(e, idPrefix)}
                                    iconName='mdi-delete'
                                    iconSide='left'
                                    iconSize='m'
                                    rendered={this.props.viewMode !== 'VIEW'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xl-6 col-lg-12'>
                        <div className='col=md-12 form-group'>

                        <ImageComponent
                            key={`${idPrefix}-quiz-photo`}
                            srcUrl={this.props.headerPhotoUrl}
                            alt='Quiz edu photo'
                            handleRemove={(e) => {
                                if(this.props.element?.headerPhoto){
                                    this.props.handleRemoveAttachment(e, this.props.element.order);                                
                                }else if(this.props.tempUrl){
                                    this.props.handleRemoveTempFileEduMaterial(e, this.props.element.order);
                                }
                            }}
                            notValidImageTypeErrorMessage={() => {
                                this.showErrorMessage(t('image.notValidImageType'));
                            }}
                            errorMessage={this.showErrorMessage}
                            imgMaxSizeParameter={this.props.imgMaxSizeParameter}
                            fileSizeToTranslation={this.props.fileSizeToTranslation}
                            attachment={this.props.element.headerPhoto}
                            setFile={this.uploadPhotoHandler}
                            t={t}
                            required={true}
                            validator={this.props.validator}
                            viewMode={this.props.viewMode}
                            fileUploadService={this.fileUploadService}                            
                        />

                            {/* {this.props.element?.headerPhoto ? (
                                <div className='editable-photo-div'>
                                    <img
                                        src={this.props.headerPhotoUrl}
                                        alt='Quiz icon'
                                        className='product-image'
                                        style={{height: '150px', width: 'auto'}}
                                    />
                                    {this.props.viewMode !== 'VIEW' ? (
                                        <ActionLink
                                            className='p-link float-right'
                                            handleClick={(e) => this.props.handleRemoveAttachment(e, this.props.element.order)}
                                            variant='red'
                                            iconName='mdi-trash-can'
                                            iconSide='left'
                                            iconSize='xs'
                                            iconColor='red'
                                        />
                                    ) : null}
                                </div>
                            ) : (
                                <div>
                                    {this.props.tempUrl && (
                                        <div>
                                            <img
                                                src={this.props.tempUrl}
                                                alt='Quiz icon'
                                                className='product-image'
                                                style={{height: '150px', width: 'auto'}}
                                            />
                                            <ActionLink
                                                className='p-link float-right'
                                                handleClick={(e) => this.props.handleRemoveTempFileEduMaterial(e, this.props.element.order)}
                                                variant='red'
                                                iconName='mdi-trash-can'
                                                iconSide='left'
                                                iconSize='xs'
                                                iconColor='red'
                                            />
                                        </div>
                                    )}
                                    {this.props.viewMode !== 'VIEW' && (
                                        <label class='custom-file-upload'>
                                            <input
                                                type='file'
                                                id='avatar'
                                                name='avatar'
                                                onChange={(e) => this.onSelect(e.target)}
                                                accept='image/*'
                                            />
                                            {t('file.choose')}
                                        </label>
                                    )}
                                </div>
                            )} */}
                        </div>
                    </div>
                    <div className='col-xl-12 col-lg-12'>
                        <InputTextEditorComponent
                            colClass='col-12'
                            id='text'
                            key={`text-${this.props.viewMode}`}
                            name='text'
                            value={this.props.element.text}
                            label={t('quiz.eduMaterialText')}
                            validator={this.props.validator}
                            validators='required'
                            rows='5'
                            onChange={this.props.handleChange}
                            viewMode={'EDIT'}
                            disabled={this.props.viewMode === 'VIEW' ? true : false}
                            autoResize
                            editorRef={this.descriptionRef}
                            restrictExt={false}
                            stateField={this.props.stateField}
                        />
                    </div>
                </div>
            </div>
        );
    }

    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
            console.log('uploadPhotoHandler', uploadedFile);
            this.props.setAttachmentForEduMaterial(this.props.element.order, uploadedFile);
        }
    }


    onSelect = (e) => {
        console.log('onSelect',this.props.imgMaxSizeParameter, e)
        if(e.fileSize < this.props.imgMaxSizeParameter)  {
            console.log('onSelect',this.props.imgMaxSizeParameter, e)
            this.setState(
                {
                    selectedFile: e,
                },
                () => {
                    this.uploadHandler();
                }
            );
        } else {
            console.error('invalid sieze');
            this.props.onErrorMessage(this.props.invalidFileSizeMessageDetail)
        }
 
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };

    uploadHandler = async () => {
        console.log('uploadHandler');
       // const selectedFile = this.state.selectedFile;
       // const formData = new FormData();
        //formData.append('file', selectedFile);
        // this.fileUploadService.uploadAttachemnt(formData).then((uploadedFile) => {
        //    this.props.setAttachmentForEduMaterial(this.props.element.order, uploadedFile);
        //});
    };
}
EduMaterialComponent.defaultProps = {
    element: null,
    idPrefix: '',
    viewMode: 'VIEW',
    stateField: 'element',
    colClass: 'col-md-4',
    disabled: false,
    imgMaxSizeParameter: '500000'
};
export default EduMaterialComponent;
